import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ValueProps from './components/ValueProps';
import ProductDemo from './components/ProductDemo';
import Agents from './components/Agents';
import Testimonials from './components/Testimonials';
// import Pricing from './components/Pricing';
import Footer from './components/Footer';
import OnboardingFlow from './components/OnboardingFlow';
import EnhancedPricingPage from './components/EnhancedPricingPage';
import AgentsPage from './pages/Agents';
import ProductPage from './pages/ProductPage';

function App() {
  const [showOnboarding, setShowOnboarding] = React.useState(false);
  
  const handleGetStarted = () => {
    setShowOnboarding(true);
  };
  
  const handleCloseOnboarding = () => {
    setShowOnboarding(false);
  };
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div className="App">
            <Navbar />
            <Hero />
            <ValueProps />
            <ProductDemo />
            <Agents />
            <Testimonials />

            <Footer />
            {showOnboarding && <OnboardingFlow onClose={handleCloseOnboarding} />}
          </div>
        } />
        <Route path="/product" element={
          <div className="App">
            <ProductPage />
          </div>
        } />
        <Route path="/agents" element={
          <div className="App">
            <AgentsPage />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
